<template>
  <v-dialog
    v-model="dialog"
    persistent
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" style="display: inline;">
        <slot name="default"></slot>
      </div>
    </template>

    <div class="vb-dialog vb-dialog-danger">
      <v-card data-cy="dialog-deleteUploadLink-modal">
        <v-card-title class="bg-red-darken-3 d-flex justify-space-between">
          <span>
            {{ $t('routes.pod.menuAccesslink.confirmDeletion') }}
          </span>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-4">
          {{ $t('menus.menuUploadLink.deleteUploadlinkDialogMessage') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btnOk" v-on:click="deleteUploadlink" elevation=0
                 data-cy="dialog-deleteUploadLink-ok">
            {{ $t('common.delete') }}
          </v-btn>
          <v-btn variant="text" @click="dialog = false" class="btnCancel"
                 data-cy="dialog-deleteUploadLink-false">
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useUploadLinkStore } from '@/stores/UploadLinkStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "UploadlinkDeleteDialog",
  props: {
    uploadlink: {
      type: Object,
      required: true,
    }
  },
  methods: {
    deleteUploadlink: async function() {
      const uploadLinkStore = useUploadLinkStore();
      try {
        await uploadLinkStore.deleteUploadLink(this.uploadlink.id);
        await uploadLinkStore.refreshUploadLinks();
        this.dialog = false;
      } catch (error) {
        console.error('Error deleting upload link:', error);
      }
    },
  }
}
</script>

<style>
</style>
